// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import React, { useContext, useEffect } from "react";
import * as _ from "underscore";
import Tool from "./Tool";
import { modelInputProps,StageProps } from "./helpers/Interfaces";
import AppContext from "./hooks/createContext";

import { imageDataToImage } from "./helpers/maskUtils";
import { resizeImage, removeBlankSpace } from "./helpers/imageUtils";
import * as tf from '@tensorflow/tfjs';

const Stage = () => {
  const {
    clicks: [clicks, setClicks],
    selected: [selected, setSelected],
    image: [image, setImage],
    maskImg: [maskImg, setMaskImg],
    segmentedImage: [segmentedImage, setSegmentedImage],
    isBrushing: [isBrushing, setIsBrushing],
    allThingmoji: [allThingmoji, setAllThingmoji]
    //set intervalthingmoji as a reference rather than a state

  } = useContext(AppContext)!;

  // console.log('clicks', clicks);
  // console.log('selected', selected);

  const peekwindowRef = React.useRef<HTMLCanvasElement>(null);
  // const contextRef = React.useRef<CanvasRenderingContext2D>(null);
  const contextRef = React.useRef<CanvasRenderingContext2D | null>(null);
  const width = 350;
  const height = 200;
  

  useEffect(() => {
    contextRef.current = peekwindowRef.current?.getContext("2d") || null;
    if (contextRef.current) {
      contextRef.current.globalAlpha = 0.2;
      contextRef.current.fillStyle = "rgba(255, 255, 255, 0)";
      contextRef.current.fillRect(0, 0, width, height);
    }
    


  },[]);

  const getClick = (x: number, y: number): modelInputProps => {
    const clickType = 1;
    return { x, y, clickType };
  };

  // const imageToUint8Array = (image: HTMLImageElement) => {
  //   const canvas = document.createElement("canvas");
  //   const context = canvas.getContext("2d");
  //   canvas.width = image.width;
  //   canvas.height = image.height;
  //   context?.drawImage(image, 0, 0);
  //   // `getImageData().data` is a `Uint8ClampedArray`, which differs from `Uint8Array` only in
  //   // how data is treated when values are being *set*, so it is valid to perform the conversion
  //   // into a `Uint8Array`.
  //   return context?new Uint8Array(context.getImageData(0, 0, image.width, image.height).data.buffer):null;
  // }

  // Get mouse position and scale the (x, y) coordinates back to the natural
  // scale of the image. Update the state of clicks with setClicks to trigger
  // the ONNX model to run and generate a new mask via a useEffect in App.tsx

  const handleMouseMove = _.throttle((e: any) => {
    if (isBrushing) {
      const { offsetX, offsetY } = e.nativeEvent;
      contextRef.current?.lineTo(offsetX, offsetY);
      contextRef.current?.stroke();

      let el = e.nativeEvent.target;
      const rect = el.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      const imageScale = image ? image.width/el.offsetWidth : 1;
      x *= imageScale;
      y *= imageScale;
      const click = getClick(x, y);
      if (click) setClicks(clicks?[...clicks,click]:[click]);
    }

  }, 50);
  
  // const handleMouseMove = _.throttle((e: any) => {
  //   let el = e.nativeEvent.target;
  //   const rect = el.getBoundingClientRect();
  //   let x = e.clientX - rect.left;
  //   let y = e.clientY - rect.top;
  //   const imageScale = image ? image.width / el.offsetWidth : 1;
  //   x *= imageScale;
  //   y *= imageScale;
  //   const click = getClick(x, y);
  //   if (click) setClicks([click]);
  // }, 15);

  const handleMouseDown = (e: any) => {
    e.preventDefault();
    // if (maskImg === null) {
      // e.preventDefault();
    contextRef.current?.clearRect(0, 0, width, height);
    const { offsetX, offsetY } = e.nativeEvent;
    contextRef.current?.beginPath();
    if (contextRef.current) {
      contextRef.current.strokeStyle = 'red';
      contextRef.current.globalAlpha = 1;
      contextRef.current.lineWidth = 3;
      // contextRef.current.numSmoothPoints = 20;
    }


    // contextRef.current.putImageData(imageImageData, 0, 0);

    contextRef.current?.moveTo(offsetX, offsetY);


      setIsBrushing(true);



    // }
  }
  const handleMouseUp = (e: any) => {
    setIsBrushing(false);
    setSelected(clicks ? [clicks[0], clicks[Math.floor(clicks.length / 2)], clicks[clicks.length - 1]] : []);
    console.log('clicks', clicks)
    setClicks([]);

    contextRef.current?.closePath();
    contextRef.current?.clearRect(0, 0, width, height);

    // console.log('image', image,'----------------')
    // const imageData = image ? imageToUint8Array(image) : null;
    // const maskImgData = maskImg ? imageToUint8Array(maskImg) : null;

    // if (image && maskImg && imageData && maskImgData) {
    //   const segmentation = new Uint8ClampedArray(maskImgData.map((pixel, index) => pixel === 0 ? 255 : imageData[index]));
    //   const croppedImage = removeBlankSpace(new ImageData(new Uint8ClampedArray(segmentation), image.width, image.height), image.width, image.height);
    //   croppedImage.addEventListener('load', event => {
    //     const resized = resizeImage(croppedImage, 250);
    //     const newItem = {
    //       resizedImage: resized,
    //       originalImage: image // Assuming 'image' is the original image you want to store
    //     };

    //     setAllThingmoji(allThingmoji ? [...allThingmoji, newItem] : [newItem]);
    //     setMaskImg(null);
    //   }, false);
    // }
  }

  // const flexCenterClasses = "flex items-center justify-center";
  return (
    <div className={`w-100 h-100`}>
      <div className={`position-relative w-100 h-100`}>
        
        <Tool handleMouseDown={handleMouseDown} handleMouseUp={handleMouseUp} handleMouseMove={handleMouseMove}
          peekwindowRef={peekwindowRef} width={width} height={height}
        />
      </div>
    </div>
  );
};

export default Stage;
